import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import { initialize as initializeForm } from "redux-form";
import { NotificationManager } from "react-notifications";
import { push } from "react-router-redux";
import { ACTIVE_GARAGE, INACTIVE_GARAGE, PENDING_GARAGE } from '../../../utility/constants';

const LOADER = 'LOADER_TALLERES';
const DATA = 'DATA_TALLERES';
const ITEM_DATA = 'ITEM_TALLERES';
const PAGE = 'PAGE_TALLERES';
const ORDERING = 'ORDERING_TALLERES';
const SEARCH = 'SEARCH_TALLERES';
const ESTADO_TALLER_TAB = 'ESTADO_TALLER_TAB';

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setData = data => ({
    type: DATA,
    data,
});

const setItem = item => ({
    type: ITEM_DATA,
    item,
});

const setPage = page => ({
    type: PAGE,
    page,
});

const setOrdering = ordering => ({
    type: ORDERING,
    ordering,
});

const setSearch = search => ({
    type: SEARCH,
    search,
});

const setEstadoTallerTab = estado_taller_tab => ({
    type: ESTADO_TALLER_TAB,
    estado_taller_tab,
});
// ------------------------------------
// Actions
// ------------------------------------
const aprobar_plan = id => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`plan/approve_plan`, { id_garage: id }).then(() => {
        dispatch(push('/garages'));
        NotificationManager.success('Suscripción activada', 'Éxito', 3000);
    }).catch((error) => {
        let mensaje = 'Error en la activación de la suscripción';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const leer = id => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${'garage'}/${id}`).then((response) => {
        dispatch(setItem(response));
        dispatch(initializeForm('TallerForm', response));
    }).catch(() => {
        dispatch(push('/'));
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const leer_payment = id => (dispatch) => {
    dispatch(setLoader(true));
    dispatch(setItem({}));
    api.get(`${'garage'}/${id}/payment_info`).then((response) => {
        dispatch(setItem(response));
        dispatch(initializeForm('TallerForm', response));
    }).catch(() => {
        dispatch(push('/'));
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


const listar = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().talleres;
    const params = { page, garage_status: resource.estado_taller_tab };

    if (resource.ordering)
        params.ordering = resource.ordering;
    if (resource.search)
        params.search = resource.search;

    dispatch(setLoader(true));
    api.get('garage', params).then((response) => {
        dispatch(setData(response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const estadoTallerTab = estado => (dispatch) => {
    dispatch(setEstadoTallerTab(estado));
    dispatch(listar());
};

const editar = (id, data = {}, attachments = []) => (dispatch) => {
    dispatch(setLoader(true));
    api.putAttachments(`garage/${id}`, data, attachments)
        .then(() => {
            NotificationManager.success('Registro actualizado', 'Éxito', 3000);
            dispatch(leer(id))
            dispatch(push('/garages'));
        })
        .catch((error) => {
            let mensaje = 'Error en la edición, vuelve a intentarlo';
            if (error) {
                if (error.detail)
                    mensaje = error.detail;
            }
            NotificationManager.error(mensaje, 'ERROR', 3000);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};


const eliminar = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`garage/${id}`).then(() => {
        dispatch(listar());
        NotificationManager.success('Registro eliminado', 'Éxito', 3000);
    }).catch(() => {
        let mensaje = 'Error en la eliminación, vuelve a intentarlo';
        if (error) {
            if (error.detail)
                mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const cleanForm = () => (dispatch) => {
    dispatch(initializeForm('TallerForm', {}));
};

const searchChange = search => (dispatch, getStore) => {
    dispatch(setSearch(search));
    dispatch(listar());
};

const onSortChange = (ordering) => (dispatch, getStore) => {
    const sort = getStore().talleres.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listar());
};


export const actions = {
    listar,
    leer,
    editar,
    eliminar,
    searchChange,
    onSortChange,
    leer_payment,
    cleanForm,
    estadoTallerTab,
    aprobar_plan,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [ESTADO_TALLER_TAB]: (state, { estado_taller_tab }) => {
        return {
            ...state,
            estado_taller_tab,
        };
    },
};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
    search: '',
    estado_taller_tab: ACTIVE_GARAGE,
};

export default handleActions(reducers, initialState);
